import { debounce, throttle } from 'throttle-debounce'
/**
 * 参考 lodash 编写的工具类函数
 *
 */
const lodashUtils = {}

const objectProto = Object.prototype
const hasOwnProperty = objectProto.hasOwnProperty
const toString = objectProto.toString

// 防抖[非 lodash 方式实现]
lodashUtils.debounce = function (fnCallback, delay) {
  return debounce(delay, false, fnCallback)
}
// 节流[非 lodash 方式实现]
lodashUtils.throttle = function (fnCallback, delay) {
  return throttle(delay, false, fnCallback, false)
}

lodashUtils.getTag = function (value) {
  if (value == null) {
    return value === undefined ? '[object Undefined]' : '[object Null]'
  }
  return toString.call(value)
}

lodashUtils.isPrototype = function (value) {
  const Ctor = value && value.constructor
  const proto = (typeof Ctor === 'function' && Ctor.prototype) || objectProto

  return value === proto
}

lodashUtils.isLength = function (value) {
  const MAX_SAFE_INTEGER = 9007199254740991
  return typeof value === 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER
}

lodashUtils.isObjectLike = function (value) {
  return typeof value === 'object' && value !== null
}

lodashUtils.isArrayLike = function (value) {
  return value != null && typeof value !== 'function' && lodashUtils.isLength(value.length)
}

lodashUtils.isArguments = function (value) {
  return lodashUtils.isObjectLike(value) && lodashUtils.getTag(value) == '[object Arguments]'
}

/**
 * 暂不支持 isTypedArray And isBuffer
 *
 * isEmpty(null)
 * => true
 *
 * isEmpty(true)
 * => true
 *
 * isEmpty(1)
 * => true
 *
 * isEmpty([1, 2, 3])
 * => false
 *
 * isEmpty('abc')
 * => false
 *
 * isEmpty({ 'a': 1 })
 * => false
 */
lodashUtils.isEmpty = function (value) {
  if (value == null) return true
  if (
    lodashUtils.isArrayLike(value) &&
    (Array.isArray(value) ||
      typeof value === 'string' ||
      typeof value.splice === 'function' ||
      lodashUtils.isArguments(value))
  ) {
    return !value.length
  }
  const tag = lodashUtils.getTag(value)
  if (tag == '[object Map]' || tag == '[object Set]') {
    return !value.size
  }
  if (lodashUtils.isPrototype(value)) {
    return !Object.keys(value).length
  }
  for (const key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false
    }
  }
  return true
}

lodashUtils.isNil = function (value) {
  return value == null
}

/**
 * 判断是否无值
 *
 * @param {*} value 值
 * @returns {boolean}
 */
lodashUtils.isNone = function (value) {
  if (lodashUtils.isNil(value)) return true
  if (lodashUtils.getTag(value) == '[object Number]') return false
  return lodashUtils.isEmpty(value)
}

/**
 * 判断上传文件的格式，默认判断 .jpg/.jpeg/.png/.gif 图片格式
 *
 * @param file
 * @param {string} file.url 文件 url
 * @param {string[]} [format=['jpg', 'jpeg', 'png', 'gif']] 待判断的文件格式
 * @param {boolean} [onlyPdf=false] 只判断是否为 pdf 格式，onlyPdf = true 时，则忽略 onlyImage
 * @param {boolean} [onlyImage=false] 只判断是否为图片格式
 *
 */
lodashUtils.checkFileFormat = function (file, format, onlyPdf = false, onlyImage = false) {
  const imgFormat = ['jpg', 'jpeg', 'png', 'gif']
  const _format = onlyImage ? imgFormat : [...new Set(format ?? imgFormat)] // 去重
  const reg = onlyPdf ? `\.pdf$` : `\.(${_format.join('|')})$` // eslint-disable-line
  const regx = new RegExp(reg, 'i')
  return regx.test(file.url)
}

export default lodashUtils
